import { createFileRoute } from '@tanstack/react-router'
import { BarChart3 } from 'lucide-react'

import { LotStatsPage } from '@/components/warehouse/lot-stats-page'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/packaging-warehouse/stats',
)({
    component: () => (
        <LotStatsPage
            kind="packaging"
            title={m.nav_packaging_stats()}
            subtitle={m.lot_stats_subtitle()}
            permission="packaging_lots.read"
            icon={BarChart3}
            groupDimLabel={m.lot_stats_dim_material()}
        />
    ),
})
